export default __webpack_public_path__ + "static/media/swift.aad6ae6a.svg";